import { UserSubscription } from '@creditsights/api-ui-web';

export enum WIDGET_ID {
  MORNING_COMMENT_LINK = 'MORNING_COMMENT_LINK',
  ANALYSTS = 'ANALYSTS',
  RELATED_TOPICS = 'RELATED_TOPICS',
  RELATED_DOCUMENTS = 'RELATED_DOCUMENTS',
  RELATED_COMPANIES = 'RELATED_COMPANIES',
  MULTIPART_DOCUMENTS = 'MULTIPART_DOCUMENTS',
}

export const DEFAULT_ARTICLE_ORDER_CONFIG: Record<UserSubscription, WIDGET_ID[]> = {
  [UserSubscription.CS_CR_LFI]: [
    WIDGET_ID.MORNING_COMMENT_LINK,
    WIDGET_ID.ANALYSTS,
    WIDGET_ID.RELATED_TOPICS,
    WIDGET_ID.MULTIPART_DOCUMENTS,
    WIDGET_ID.RELATED_DOCUMENTS,
    WIDGET_ID.RELATED_COMPANIES,
  ],
  [UserSubscription.CS_CR]: [
    WIDGET_ID.MORNING_COMMENT_LINK,
    WIDGET_ID.ANALYSTS,
    WIDGET_ID.RELATED_TOPICS,
    WIDGET_ID.MULTIPART_DOCUMENTS,
    WIDGET_ID.RELATED_DOCUMENTS,
    WIDGET_ID.RELATED_COMPANIES,
  ],
  [UserSubscription.CS_LFI]: [
    WIDGET_ID.MORNING_COMMENT_LINK,
    WIDGET_ID.ANALYSTS,
    WIDGET_ID.RELATED_TOPICS,
    WIDGET_ID.MULTIPART_DOCUMENTS,
    WIDGET_ID.RELATED_COMPANIES,
  ],
  [UserSubscription.CR_LFI]: [
    WIDGET_ID.ANALYSTS,
    WIDGET_ID.RELATED_TOPICS,
    WIDGET_ID.RELATED_DOCUMENTS,
    WIDGET_ID.RELATED_COMPANIES,
  ],
  [UserSubscription.CS]: [
    WIDGET_ID.MORNING_COMMENT_LINK,
    WIDGET_ID.ANALYSTS,
    WIDGET_ID.RELATED_TOPICS,
    WIDGET_ID.MULTIPART_DOCUMENTS,
    WIDGET_ID.RELATED_COMPANIES,
  ],
  [UserSubscription.CR]: [
    WIDGET_ID.ANALYSTS,
    WIDGET_ID.RELATED_TOPICS,
    WIDGET_ID.RELATED_DOCUMENTS,
    WIDGET_ID.RELATED_COMPANIES,
  ],
  [UserSubscription.LFI]: [WIDGET_ID.ANALYSTS, WIDGET_ID.RELATED_TOPICS, WIDGET_ID.RELATED_COMPANIES],
};
